import { TabView, TabPanel } from "primereact/tabview"

import NotificationSettingsTab from "./NotificationSettingsTab"
import NotificationsTab from "./NotificationsTab"
import NotificationsSystemTab from "./NotificationsSystemTab"
import { useEffect, useState } from "react"

export default function NotificationsForm({
  ActiveKey,
  organizationList,
  getOrganizationName,
  onRefreshBellCounter,
  onShowError,
  onShowNotification,
  onHandleActionURL,
  onSetMutedNotifications,
  onResetActiveKey,
}) {
  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => {
    if (ActiveKey) {
      switch (ActiveKey) {
        case "":
        case "notifications":
          setSelectedIndex(0)
          break
        case "sys-notifications":
          setSelectedIndex(1)
          onResetActiveKey()
          break
        case "mute":
          setSelectedIndex(2)
          onResetActiveKey()
          break
        default:
          setSelectedIndex(0)
          break
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ActiveKey])

  return (
    <TabView
      activeIndex={selectedIndex}
      onTabChange={(e) => setSelectedIndex(e.index)}
    >
      <TabPanel header="My notifications">
        <NotificationsTab
          onShowError={onShowError}
          organizationList={organizationList}
          onHandleActionURL={onHandleActionURL}
          onRefreshBellCounter={onRefreshBellCounter}
          getOrganizationName={getOrganizationName}
        />
      </TabPanel>
      <TabPanel header="System notifications">
        <NotificationsSystemTab
          onShowError={onShowError}
          onShowNotification={onShowNotification}
          onRefreshBellCounter={onRefreshBellCounter}
          getOrganizationName={getOrganizationName}
        />
      </TabPanel>
      <TabPanel header="Manage notifications">
        <NotificationSettingsTab
          onSetMutedNotifications={(x) => {
            onSetMutedNotifications(x)
          }}
        />
      </TabPanel>
    </TabView>
  )
}
